import { createRouter, createWebHistory } from 'vue-router'

import HomeThreePage from "../Pages/HomeThreePage.vue";
import AboutPage from "../Pages/AboutPage.vue";
import InstructorTwoPage from "../Pages/InstructorTwoPage.vue";
import InstructorDetailsPage from "../Pages/InstructorDetailsPage.vue";
import CoursesPage from "../Pages/CoursesPage.vue";
import CoursesListPage from "../Pages/CoursesListPage.vue";
import CoursesDetailsPage from "../Pages/CoursesDetailsPage.vue";
import ContactPage from "../Pages/ContactPage.vue";
import ErrorPage from "../Pages/ErrorPage.vue";

const routes = [
  {
    path: "/",
    name: "HomeThreePage",
    component: HomeThreePage,
  },
  {
    path: "/about",
    name: "AboutPage",
    component: AboutPage,
  },
  {
    path: "/instructor",
    name: "InstructorTwoPage",
    component: InstructorTwoPage,
  },
  {
    path: "/instructor-details/:id",
    name: "InstructorDetailsPage",
    component: InstructorDetailsPage,
  },
  {
    path: "/courses",
    name: "CoursesPage",
    component: CoursesPage,
  },
  {
    path: "/courses-list",
    name: "CoursesListPage",
    component: CoursesListPage,
  },
  {
    path: "/courses-details/:id",
    name: "CoursesDetailsPage",
    component: CoursesDetailsPage,
  },
  {
    path: "/contact",
    name: "ContactPage",
    component: ContactPage,
  },
  {
    path: "/:pathMatch(.*)*",
    name: "ErrorPage",
    component: ErrorPage,
  },
]

const router = createRouter({
  history: createWebHistory(),
  routes,
  linkExactActiveClass: "active",
  scrollBehavior() {
    return { top: 0, behavior: "smooth" };
  },
})

export default router
